// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mt-0";
export var buttonContainer = "_mt-3";
export var cancelButton = "_mt-4";
export var headerSection = "_mt-6";
export var headerTitle = "_mt-9";
export var messageSideLeft = "_mt-1";
export var messageSideRight = "_mt-2";
export var orderNumberContainer = "_mt-7";
export var orderNumberLabel = "_mt-8";
export var submitButton = "_mt-5";